import userService from '@/service/userService'
import axios from 'axios'
import MainPresenter from "@/service/MainPresenter"
import appConfig from '@/service/config'
import moment from 'moment'
import un from 'underscore'

const mainPresenter = new MainPresenter();

const ExpensesService = function() {

    function buildParamsSearch(requestData) {
        return {
            "storeId": requestData.params.selectedStoreId,
            "expenseName": requestData.params.search,
            "itemsPage": requestData.pageable.page,
            "itemsSize": 60
        }
    }

    this.loadExpense = function(expenseId, onSuccess, onError) {
        const req = axios({
            method: 'get',
            url: appConfig.baseUrl + `/expenses/${expenseId}`,
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(e => {
            onError(e)
        })
    }

    this.delete = function(expenseId, onSuccess, onError) {
        const req = axios({
            method: 'delete',
            url: appConfig.baseUrl + `/expenses/${expenseId}`,
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(e => {
            onError(e)
        })
    }

    this.search = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'get',
            url: mainPresenter.getUrlForParams("/expenses", buildParamsSearch(requestData)),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(e => {
            onError(e)
        })
    }

    function buildParamsAdd(requestData) {
        return {
            expenseName: requestData.expenseName,
            expenseDesc: requestData.expenseDesc,
            expensePrice: requestData.expensePrice,
            expenseDate: moment(requestData.expenseDate).format("YYYY-MM-DD HH:mm:ss"),
            storeId: requestData.storeId,
        }
    }

    function buildParamsUpdate(requestData) {
        const data = JSON.parse(JSON.stringify(buildParamsAdd(requestData)));
        data.expenseId = requestData.expenseId
        return data
    }

    this.update = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'patch',
            url: appConfig.baseUrl + '/expenses',
            data: buildParamsUpdate(requestData),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    this.add = function(requestData, onSuccess, onError) {
        const req = axios({
            method: 'post',
            url: appConfig.baseUrl + '/expenses',
            data: buildParamsAdd(requestData),
            headers: {
                Authorization: userService.getAuthHeader()
            }
        });
        req.then(res => {
            onSuccess(res.data)
        }).catch(err => {
            const errors = un.map(err.response.data.errors, item => {
                return item.defaultMessage
            })
            onError(errors)
        })
    }

    function filterStores(stores, currentStoreId) {
        return un.filter(stores, store => {
            return store.id === currentStoreId
        })
    }

    this.initStores = function(onSuccess, onError) {
        axios.get(mainPresenter.buildUrlWithDefaults("/allStores?visible=true")).then(response => {
            const currentStore =  userService.getCurrentStore();
            const stores = response.data.content
            if (this.isAdmin()) {
                onSuccess(stores, currentStore);
            } else {
                onSuccess(filterStores(stores, currentStore), currentStore)
            }

        }, err => {
            console.log(err)
        })
    }

    this.isAdmin = function() {
        return userService.isAdmin()
    }

    this.canEdit = function(item) {
        if (this.isAdmin()) {
            return true
        }
        const user = userService.getCurrentUser()
        return item.createdBy === user.name;
    }

    this.canDelete = function(item) {
        return this.canEdit(item)
    }

    return {
        "search": this.search,
        "isAdmin": this.isAdmin,
        "initStores": this.initStores,
        "add": this.add,
        "canEdit": this.canEdit,
        "loadExpense": this.loadExpense,
        "update": this.update,
        "delete": this.delete,
        "canDelete": this.canDelete
    }
}

export default ExpensesService;



// WEBPACK FOOTER //
// ./src/components/expenses/ExpensesService.js